import api from 'api'
import { ShiftDetail } from 'pages/Shifts/ShiftDetail/types'

export const getShiftById = async (shiftId: number): Promise<ShiftDetail> => {
  const response = await api.get(`/admin/shift/${shiftId}`)
  return response.data
}
